<template>
  <div>
    <!-- List Table -->
    <List
      :header="header"
      :data="data"
      :pagination="pagination"
      :loading="loading"
      @updatePage="updatePage"
    >
      <template v-slot:item.name="{ item }">
        <div class="overflowAuto">
          {{
            item.playbook && item.playbook.data
              ? $customFunctions.controlSpace(item.playbook.data.name)
              : '-'
          }}
        </div>
      </template>
      <template v-slot:item.last_execution_time="{ item }">
        {{
          $customFunctions.setMomentWithFormat(
            item.last_execution_time,
            'ddd MMM DD YYYY HH:mm:ss'
          )
        }}
      </template>
    </List>
  </div>
</template>

<script>
// Utils
import EventBus from '@/event-bus'

// Services
import ApiService from '@/core/services/api.service'

export default {
  name: 'Executions',
  data() {
    return {
      search: '',
      loading: false,
      header: [
        { text: 'servers.playbookName', value: 'name', size: '3fr' },
        { text: 'IP v4', value: 'ip_v4', size: '2fr', copyField: true },
        {
          text: 'servers.lastExecutionTime',
          value: 'last_execution_time',
          size: '2fr',
        },
        {
          text: 'servers.executionTotalTime',
          value: 'execution_total_time',
        },
        { text: 'servers.resultOk', value: 'result_ok' },
        { text: 'servers.resultChanged', value: 'result_changed' },
        {
          text: 'servers.resultUnreachable',
          value: 'result_unreachable',
        },
        { text: 'servers.resultFailed', value: 'result_failed' },
        { text: 'servers.resultSkipped', value: 'result_skipped' },
        { text: 'servers.resultRescued', value: 'result_rescued' },
        { text: 'servers.resultIgnored', value: 'result_ignored' },
      ],
      data: [],
      pagination: {},
      meta: {},
    }
  },
  created() {
    this.getList()
  },
  mounted() {
    EventBus.$on(`subHeaderSearch`, this.listener)
  },
  beforeDestroy() {
    EventBus.$off(`subHeaderSearch`, this.listener)
  },
  methods: {
    listener(payload) {
      this.search = payload
      this.getList()
    },
    getList() {
      this.loading = true

      const { current_page } = this.meta

      let $query = `ansible/playbook/all-executions?include=playbook&position=id|desc&page=${
        current_page ? current_page : 1
      }`

      if (this.search) $query += `&name=${this.search}`

      ApiService.get($query)
        .then(({ data }) => {
          this.data = data.data
          this.pagination = data.meta ? data.meta.pagination : {}

          this.loading = false
        })
        .catch((err) => {
          console.log(err)
          this.data = []
          this.loading = false
        })
    },
    updatePage(value) {
      this.meta = value

      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    },
    closeDetail() {
      this.showDetail = false
    },
  },
  watch: {
    meta: {
      handler() {
        this.getList()
      },
      deep: true,
    },
  },
}
</script>
